import React, { useCallback } from 'react';
import { result, first } from 'underscore';
import PropTypes from 'prop-types';
import { Label, Stack } from '@fluentui/react';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { UrlPathFluent as UrlPathFluentV1 } from '@bingads-webui-campaign-react/url-input-fluent';
import { UrlPathFluent as UrlPathFluentV2 } from '@bingads-webui-campaign-react/url-input-fluent-v2';
import { withFluentSwitcher } from '@bingads-webui-react/fluent-version-switcher';

const UrlPathFluent = withFluentSwitcher(UrlPathFluentV1, UrlPathFluentV2);

const UrlPathWithCustomValidation = ({
  validationProps,
  updateValidation,
  i18n,
}) => {
  const { data } = validationProps;

  const urlPath1 = result(data, 'Path1', '');
  const urlPath2 = result(data, 'Path2', '');
  const finalUrl = first(result(data, 'FinalUrls', ['']));

  const onChange = useCallback((errors, value) => {
    updateValidation(errors, value);
  }, [updateValidation]);

  return (
    <div className="url-path-container">
      <Label>
        <Stack horizontal verticalAlign="center" >
          {i18n.getString(_TL_('Path'))}
          <HelpPopupInline topic="pop_BA_NewAdCreate_Path" />
        </Stack>
      </Label>
      <UrlPathFluent
        value={[urlPath1, urlPath2]}
        url={finalUrl}
        onChange={onChange}
        i18n={i18n}
      />
    </div>
  );
};

UrlPathWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      Path1: PropTypes.string,
      Path2: PropTypes.string,
      FinalUrls: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedUrlPath = withError(withCustomValidation(UrlPathWithCustomValidation));
